import React from 'react';
import './FAQ.css';

const FAQ = () => {
  const faqs = [
    {
      question: "What can the AI Trading Coach help me with?",
      answer: "The AI Coach acts as a mentor. You can ask it specific questions like 'Why did I lose this trade?' or 'How can I improve my risk management?' It analyzes your journaled data to provide personalized, data-driven answers."
    },
    {
      question: "How does the chart analysis tool work?",
      answer: "Simply upload a screenshot of your chart. Our AI vision model scans the image to identify key technical levels, trend lines, and potential patterns, giving you a second opinion on your analysis."
    },
    {
      question: "What kind of behavioral insights does the AI provide?",
      answer: "The AI tracks patterns in your notes and emotions. For example, it might tell you, 'When you note feeling anxious, your win rate drops by 20%' or 'You tend to exit winning trades too early when trading EUR/USD.' This helps you master your trading psychology."
    },
    {
      question: "Is my trading data private?",
      answer: "Your privacy is our priority. Trade logs, financial data, and personal notes are encrypted. To power advanced features like the AI Coach, anonymized data is processed by select third-party AI providers. This data is stripped of all personal identifiers and is never linked to your identity."
    },
    {
      question: "Does it work for all markets?",
      answer: "Yes, LunarLog AI is designed for traders of all markets—Stocks, Forex, Crypto, Futures, and Options. The AI principles of psychology and technical analysis apply universally."
    }
  ];

  return (
    <section id="faq" className="faq">
      <div className="container">
        <h2 className="section-title">Frequently Asked Questions</h2>
        <p className="section-subtitle">Everything you need to know about LunarLog AI</p>
        
        <div className="faq-grid">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item card">
              <h3>{faq.question}</h3>
              <p>{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
